exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fleet-types-carousel .navigation[data-v-41cfe58d] {\n  position: absolute;\n  bottom: 15px;\n  right: 7px;\n}\n.fleet-types-carousel .navigation button i[data-v-41cfe58d]::before {\n  color: #fff;\n  font-size: 1.5rem;\n}\n.fleet-types-carousel .navigation button.button-prev[data-v-41cfe58d] {\n  margin-right: 20px;\n}", ""]);

// exports
